<template>
	<div style="background-color: #f5f5f5;min-height: 100vh;">
		<!-- 购物车增改结算 -->
			<div class="goods-card"  v-if="token&&cartTotalNum>0">
				<div class="cart-zone-title" style="background-color:#ffffff ;padding: 10px 10px 10px 10px;">已选商品{{totalNum}}件 (左滑动删除商品)</div>				
				<div style="margin-bottom: 80px;padding: 10px 10px;">								
						<div  v-if="list.item_list.length>0" v-for="(list,index) in cartList" :key="index" style="background-color: #ffffff;margin-bottom: 15px;border-radius: 10px;padding: 10px 0;">
								<div style="display: flex;padding: 10px 10px;align-items: center;">
									<van-checkbox v-model="list.checked" @click='partCheckChange(list)' :name='index' checked-color="#ee0a24"></van-checkbox>
									<div style="margin: 0 5px 0 10px;display: flex;align-items: center;">
										<van-tag type="primary " v-if="list.is_presell == 2">{{list.tag}}</van-tag>
										<van-tag type="success" v-else>{{list.tag}}</van-tag>
									</div>
									<div style="font-size: 14px;">{{list.category_name}}</div>									
								</div>
								<div v-for="(item,index) in list.item_list" :key="index" style="margin-bottom: 10px;display: flex; ">
									<van-checkbox :name="item.id" v-model="item.checked" style="margin: 0 10px;" checked-color="#ee0a24"></van-checkbox>
									<van-swipe-cell  style="flex: 1;">
										<van-card
										  class="good-card"
										  :price="item.vip_price.toFixed(2)"
										  :desc="item.size ? item.size+'/'+item.unit_name : ''"
										  :title="item.item_name"
										  :thumb="item.thumb_image"
										  centered
										  :tag='item.limit_num && item.cart_source =="group" ? "每人限购"+item.limit_num+"件" : ""'
										>
										  <template #footer>
												 <van-stepper v-model="item.goods_num"  min="0" @change="carNumChange(item)" :max='item.limit_num?item.limit_num:"999"' />
										  </template>	  
										</van-card>									
										<template #right>
											<van-button square text="删除" type="danger" class="delete-button" @click="delCartItemAsync(item)"/>
										</template>
									</van-swipe-cell>	
								</div>
														
						</div>							
													
				</div>	  			
				<!-- 购物车结算 -->
				<van-submit-bar :price="lastTotalPrice*100" button-text="提交" @submit="onSubmit" :disabled='cartTotalPrice<=0'    style="margin-top: 20px;margin-bottom: 50px;" >					
					 <template>
						 <div style="display: flex;">
							  <van-checkbox v-model="allChecked"  @click="changeAll" name="all" checked-color="#ee0a24">全选</van-checkbox>
							  <div v-if="lastTotalPrice != cartTotalPrice" style="margin-left: 10px;display: flex;flex-direction: column;font-size: 12px;">					  
								  <del style="color: #909399;">原价:{{cartTotalPrice}}</del>
								  <span style="color: #ee0a24;">减{{reduceCount.reduction_amount}}</span>
							  </div>
						 </div>
						 
					 </template>
					
					  <template #tip v-if="reductionList.length && totalNum">
					     <div style="display: flex;justify-content: center;">
							 <div style="margin-right: 10px;" v-if="reduceCount && reduceCount.id">
							 	已满{{reduceCount.min_amount}}减{{reduceCount.reduction_amount}}
							 </div>
							 <div style="margin-left: 40rpx;" v-if="moreReduceCount && moreReduceCount.id">
							 	还需{{(moreReduceCount.min_amount-cartTotalPrice).toFixed(2)}}元，即可减{{moreReduceCount.reduction_amount}}元
							 </div>
						 </div>			
					  </template>
					 					  
				</van-submit-bar>
			</div>
			<div v-else>
				<van-empty description="购物车空空如也">
				  <van-button round type="danger" class="bottom-button" @click="goShop">去购物</van-button>
				</van-empty>
			</div>
		<van-tabbar route placeholder safe-area-inset-bottom active-color="#42C052">
		   <van-tabbar-item replace to='/activityList' icon="home-o">首页</van-tabbar-item>
		   <van-tabbar-item replace to="/cart" icon="cart-o" :badge="cartTotalNum>0 ? cartTotalNum :''">购物车</van-tabbar-item>
		   <van-tabbar-item replace to="/userCenter" icon="user-o">我的</van-tabbar-item>
		 </van-tabbar>
	</div>
</template>

<script>
	import {mapState, mapMutations,mapActions} from 'vuex'
	export default{
		name:'cart',
		computed:{
			   ...mapState(['cartList','token',,'cartTotalNum']),
			   selectList(){
				   let arr = []
				   this.cartList.map(item=>{
					   item.item_list.map(i=>{
						   arr.push(i)
					   })
				   })
				   return arr.filter(item=>item.checked == true)
			   },
			   // 已选择的商品数量
			  totalNum(){
			   		  return this.selectList.reduce((sum,item) => sum + item.goods_num, 0)
			   },
			   // 购物车商品价格
			   cartTotalPrice(){
			   		  var totalPrice = this.selectList.reduce((sum,item) => sum + (item.vip_price*item.goods_num), 0)
			   		  totalPrice=totalPrice.toFixed(2)
			   		  return totalPrice
			   },
			   //优惠完之后的最终价格
			   lastTotalPrice(){
			   	let reduce = this.reduceCount.reduction_amount ? this.reduceCount.reduction_amount :0
			   	let result = (this.cartTotalPrice-reduce).toFixed(2)
			   	return result
			   },
			   //构建购物车id数组
			   cartIdPay(){
			       let cartId=[]
			       for(var i=0;i<this.selectList.length;i++){
			   	   cartId.push(this.selectList[i].id)
			       }
			       return cartId
			   },
				//满减金额
				reduceCount(){
					let obj = {}
					if(!this.reductionList){
						obj = {}
					}else{
						let filterList = this.reductionList.filter(item=>Number(this.cartTotalPrice) > Number(item.min_amount) )
						if(filterList.length == 0){
							obj = {}
						}else{
							// obj = filterList[filterList.length-1]	
							//选取最优惠的
							filterList.sort(function(a,b){
								return Number(b.reduction_amount) -Number(a.reduction_amount)
							})
								
							obj = filterList[0]
						}
					}
					//console.log(obj)
					return  obj
				},
				moreReduceCount(){
					
					let obj = {}
					if(this.reductionList){	
						//未到达金额的满减活动数组
						let filterList = this.reductionList.filter(item=>Number(this.cartTotalPrice)< Number(item.min_amount) )
						if(filterList){						
							//和已经满减的比较，比满减的大的活动数组
							let reduction_amount  = this.reduceCount.reduction_amount ? this.reduceCount.reduction_amount: 0
							let reFilterList = filterList.filter(item=>Number(item.reduction_amount) > Number(reduction_amount))
							
							if(reFilterList){
								//比满减活动优惠大的，未达到最小的满减金额的那个满减活动
								reFilterList.sort(function(a,b){
									return Number(a.min_amount) - Number(b.min_amount)
								})							
								obj = reFilterList[0]				
							}else{
								obj ={}
							}
						}else{
							obj ={}
						}
					}else{
						obj ={}
					}				
					return obj				
					
					
					
				}		  
			   
		},
		
		data(){
			return {
				allChecked:true,
				reductionList:[],//满减列表
				reductionGift:'',//优先级
				giftList:[],//满赠列表

			}
		},
		
		watch:{
			cartList:{
				handler(){
					//全选按钮的变化
					this.allChecked=this.cartList.every(item=>{
							return item.checked
					})
					//部分按钮的变化
					this.cartList.map(item=>{
						item.checked = item.item_list.every(i=>{
							return i.checked
						})
					})
				},
				deep:true
			}
		},
		methods:{
			...mapActions(['modifyCartAsync','delCartItemAsync','cartGetAsync']),
			
			//分类全选按钮
			partCheckChange(item){
				item.checked = !item.checked
				item.item_list.map(i=>{
					i.checked = item.checked
				})
			},
			//全选按钮
			changeAll(){
				this.cartList.map(item=>{
					item.checked = this.allChecked
					item.item_list.map(i=>{
						i.checked = this.allChecked
					})
				})
			},
			
			//提交购物车订单支付
			onSubmit(){
				this.$router.push({
					path:'/orderSubmit',
					query:{
						detail:JSON.stringify(this.cartIdPay),
						cartTotalPrice:this.cartTotalPrice,
						lastTotalPrice:this.lastTotalPrice,
						reductionGift:this.reductionGift,
						giftList:JSON.stringify(this.giftList),
						reduceCount:this.reduceCount
					}
				})
			},
			//当购物车中商品数量变化时
			carNumChange(product){
				if(product.goods_num==0){
				  this.delCartItemAsync(product)				 
				} else {
				  this.modifyCartAsync(product)
				}
			},
			goShop(){
				if(!this.token){
					this.$wxLogin();
				}
				this.$router.push('/')
			},
			//获取满减满赠活动
			getReductionGift(){
				this.request.postURL('/api/cart/getReductionGift',{					
				 }).then((res)=>{					
					this.reductionList = res.data.data.reduction_list
					this.reductionGift = res.data.data.reduction_gift
					this.giftList = res.data.data.gift_list
					//console.log(this.reductionList)
				 }).catch((err)=> {
					
				   });
			},
		},
		mounted() {
			this.cartGetAsync()
			this.getReductionGift()
		}
	}
</script>

<style scoped>
	.goods-card{
		width: 100%;
		text-align: left;
	}
	.good-card{
		background-color: #ffffff;
		padding: 5px 20px;
	}
	.cart-zone-title{
		font-size: 16px;
		padding: 20px 0 0 20px;
	}
	.delete-button {
	    height: 100%;
	  }
	.back-index{
		width: 40px;
		height:40px;
		vertical-align: middle;
		background-color: rgba(255,255,255,.3);
		border-radius: 40px;
		position: absolute; 
		top: 3px; 
		left: 10px; 
		z-index:99;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.activity-text{
		padding:5px 20px;
		text-align: left;
	}
	.activity-text p{
		margin:0 0 8px 0;
	}
	.activity-text p img{
		
		
	}
	.activity-text img{
		width: 100%;
	}
	.van-tab--active{
		font-weight: 800;
	}
	.colon {
	  display: inline-block;
	  margin: 0 4px;
	  color: #fff;
	  font-size: 16px;
	}
	.block {
	  display: inline-block;
	  width: 22px;
	  color: #fff;
	  font-size: 16px;
	  text-align: center;
	  background-color: #ee0a24;
	}
	.good-card{
		padding: 0  20px 0 0;
	}
</style>
